import { action } from "typesafe-actions";
import { IModuleSetting } from "./moduleSetting.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";

export const FETCH_MODULE_SETTING_LIST_PROGRESS = "FETCH_MODULE_SETTING_LIST_PROGRESS";
export const FETCH_MODULE_SETTING_LIST_SUCCESS = "FETCH_MODULE_SETTING_LIST_SUCCESS";
export const FETCH_MODULE_SETTING_LIST_FAILED = "FETCH_MODULE_SETTING_LIST_FAILED";

export const fetchModuleSettingListProgress = () => action(FETCH_MODULE_SETTING_LIST_PROGRESS);
export const fetchModuleSettingListSuccess = (data: IModuleSetting[], totalRecords: number) =>
  action(FETCH_MODULE_SETTING_LIST_SUCCESS, { data, totalRecords });
export const fetchModuleSettingListFailed = () => action(FETCH_MODULE_SETTING_LIST_FAILED);

export const fetchModuleSettingListAsync = (
  companyOutletUuid: string,
  moduleName: string
): ThunkAction<void, IStoreState, {}, AnyAction> => async (dispatch) => {
  try {
    dispatch(fetchModuleSettingListProgress());
    // dispatch(saveLoaderProgress());

    const finalUrl = `/siteConfiguration/get-company-outlet-module-settings?company_outlet_uuid=${companyOutletUuid}&module_name=${moduleName}`;

    const res = await api.get(finalUrl);
    const data: IModuleSetting[] = res.data.data;
    const totalRecords = res.data.totalRecords || data.length;

    dispatch(fetchModuleSettingListSuccess(data, totalRecords));
  } catch (err: any) {
    dispatch(fetchModuleSettingListFailed());
    dispatch(
      showMessage({
        type: "error",
        message: err.response?.data?.message || "Failed to fetch module settings",
        displayAs: "snackbar",
      })
    );
  } finally {
    dispatch(saveLoaderCompleted());
  }
};

export const upsertModuleSettingAsync = (
  data: IModuleSetting,
  onCallback: (isSuccess: boolean) => void
): ThunkAction<void, IStoreState, {}, AnyAction> => async (dispatch) => {
  try {
    dispatch(saveLoaderProgress());
    await api.post("/siteConfiguration/upsert-company-outlet-module-setting", {
      ...data,
    });
    dispatch(
      showMessage({
        type: "success",
        message: "Module setting saved successfully!",
        displayAs: "snackbar",
      })
    );
    onCallback(true);
  } catch (err: any) {
    onCallback(false);
    dispatch(
      showMessage({
        type: "error",
        message: err.response?.data?.message || "Failed to save module setting",
        displayAs: "snackbar",
      })
    );
  } finally {
    dispatch(saveLoaderCompleted());
  }
};

export const CLEAR_MODULE_SETTING_STATE = "CLEAR_MODULE_SETTING_STATE";
export const clearModuleSettingState = () => action(CLEAR_MODULE_SETTING_STATE);
